<h1 mat-dialog-title>
  {{ this.title }}
  @if (icon) {
    <mat-icon>{{ this.icon }}</mat-icon>
  }
  @if (svgIcon) {
    <mat-icon class="!h-8" [svgIcon]="svgIcon" [inline]="true" />
  }
</h1>

<mat-dialog-content>
  <div class="whitespace-pre-line pb-12 pt-8 text-center text-lg/none">
    {{ this.body }}
  </div>
  <table-like-layout
    appearance="flat"
    [values]="values"
    [config]="config"
    [shouldHideTotal]="true"
    (valueChanged)="handleValueChange()"
  />
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="primary" [disabled]="isButtonDisabled" (click)="handlePromptClicked()">
    Remember Mapping
  </button>
</mat-dialog-actions>
